var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { staticClass: "seo" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "form__wrapper" }, [
            _c("label", { staticClass: "form__label", attrs: { for: "" } }, [
              _c("span", [_vm._v("Title")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.meta.title,
                    expression: "meta.title"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.meta.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.meta, "title", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "form__label", attrs: { for: "" } }, [
              _c("span", [_vm._v("Keywords")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.meta.keywords,
                    expression: "meta.keywords"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.meta.keywords },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.meta, "keywords", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "form__label", attrs: { for: "" } }, [
              _c("span", [_vm._v("Description")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.meta.description,
                    expression: "meta.description"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.meta.description },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.meta, "description", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "form__label", attrs: { for: "" } }, [
              _c("span", [_vm._v("Canonical")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.meta.canonical,
                    expression: "meta.canonical"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.meta.canonical },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.meta, "canonical", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "seo-edit-submit" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-big btn-green",
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [_vm._v("\n                    Speichern\n                ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "seo-edit-content btn btn-big btn-green",
              on: { click: _vm.toggleChange }
            },
            [
              !_vm.isEditMode
                ? _c("span", [_vm._v("Edit")])
                : _c("span", [_vm._v("Cancel")])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.currentTarget
          ? _c("div", { staticClass: "modal-wrapper" }, [
              _c("div", { staticClass: "cart-mobile" }, [
                _c(
                  "span",
                  { staticClass: "cart-header__btn", on: { click: _vm.close } },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M14 1.225L12.775 0L7 5.775L1.225 0L0 1.225L5.775 7L0 12.775L1.225 14L7 8.225L12.775 14L14 12.775L8.225 7L14 1.225Z",
                            fill: "black"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "cart-header" }, [
                  _vm._v("\n                Edit\n            ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-editor" },
                  [
                    _c("trumbowyg", {
                      staticClass: "form-control",
                      attrs: { config: _vm.configs.basic, name: "content" },
                      model: {
                        value: _vm.currentTarget.content,
                        callback: function($$v) {
                          _vm.$set(_vm.currentTarget, "content", $$v)
                        },
                        expression: "currentTarget.content"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "seo-edit-save btn btn-big btn-green",
                    on: {
                      click: function($event) {
                        return _vm.close()
                      }
                    }
                  },
                  [_vm._v("\n                Save\n            ")]
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }